/**
 * Powerful Form Builder: お問い合わせフォームの補足文改行を整える
 * 全角スペース区切りの注記を、意味の通る位置で改行する
 */
(() => {
  const HELP_MARKER = '※添付いただけるファイルサイズ';
  const SELECTOR =
    '.globo-form-id-11113 .help-text.globo-description, .globo-form-app[data-id="11113"] .help-text.globo-description';

  function fixHelpText(root = document) {
    root.querySelectorAll(SELECTOR).forEach((el) => {
      if (el.dataset.lineBreakFixed === 'true') return;

      const text = el.textContent || '';
      if (!text.includes(HELP_MARKER)) return;

      const lines = text
        .split(/\u3000+/)
        .map((line) => line.trim())
        .filter(Boolean);

      if (lines.length < 2) return;

      el.dataset.lineBreakFixed = 'true';
      el.innerHTML = lines.join('<br>');
    });
  }

  fixHelpText();

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node.nodeType !== Node.ELEMENT_NODE) continue;
        if (
          node.matches?.(SELECTOR) ||
          node.querySelector?.(SELECTOR) ||
          node.classList?.contains('globo-formbuilder') ||
          node.classList?.contains('globo-form')
        ) {
          fixHelpText(node);
        }
      }
    }
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
